export const all_routes = {
  tenantsNestfinApp: "https://tenants.nestfin.app",
};
